<!-- Floating Action Button (hidden when chat is open and not minimized) -->
<button class="chatbot-fab" *ngIf="!isOpen || isMinimized" (click)="toggleChat()" aria-label="Open chat">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="white"/>
        <circle cx="8" cy="10" r="1.2" fill="white"/>
        <circle cx="12" cy="10" r="1.2" fill="white"/>
        <circle cx="16" cy="10" r="1.2" fill="white"/>
    </svg>
</button>

<!-- Chat Window -->
<div class="chatbot-window" *ngIf="isOpen && !isMinimized">
    <!-- Header -->
    <div class="chatbot-header">
        <div class="chatbot-header-title">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" style="margin-right: 0.5rem; flex-shrink: 0;">
                <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="#26efe9"/>
            </svg> -->
            {{ chatTitle }}
        </div>
        <div class="chatbot-header-actions">
            <button class="chatbot-icon-btn" (click)="toggleMinimize()" [attr.aria-label]="isMinimized ? 'Expand chat' : 'Minimize chat'">
                <svg *ngIf="!isMinimized" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M19 13H5v-2h14v2z" fill="white"/>
                </svg>
                <svg *ngIf="isMinimized" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" fill="white"/>
                </svg>
            </button>
            <!-- <button class="chatbot-icon-btn" (click)="toggleChat()" aria-label="Close chat">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="white"/>
                </svg>
            </button> -->
        </div>
    </div>

    <!-- Body (hidden when minimized) -->
    <div class="chatbot-body" *ngIf="!isMinimized">

        <!-- Tabs -->
        <nav class="chatbot-tabs-nav">
            <ul class="chatbot-tabs-list">
                <li class="chatbot-tab-item"
                    [ngClass]="{ active: activeTab === 'transcript' }"
                    (click)="activeTab = 'transcript'">
                    <a class="chatbot-tab-link">Transcript</a>
                </li>
                <li class="chatbot-tab-item"
                    [ngClass]="{ active: activeTab === 'ai-suggestion' }"
                    (click)="activeTab = 'ai-suggestion'">
                    <a class="chatbot-tab-link">AI Suggestion</a>
                </li>
            </ul>
        </nav>

        <!-- Transcript Tab -->
        <ng-container *ngIf="activeTab === 'transcript'">
            <div class="chatbot-transcript-panel" *ngIf="showTranscript">
                <app-call-transcript></app-call-transcript>
            </div>
            <div class="chatbot-no-transcript" *ngIf="!showTranscript">
                <p>No transcript available.</p>
            </div>

        </ng-container>

        <!-- AI Suggestion Tab -->
        <ng-container *ngIf="activeTab === 'ai-suggestion'">

            <div class="chatbot-messages" #messageList>

                <!-- Greeting -->
                <div class="chatbot-greeting">
                    <p class="chatbot-greeting-text">
                        Welcome! I'm your KB Assistant. Ask me anything about insurance, quotes or policies to get started.
                    </p>
                </div>

                <!-- Messages -->
                <div *ngFor="let msg of messages"
                     class="chatbot-message"
                     [class.user]="msg.role === 'user'"
                     [class.bot]="msg.role === 'bot'">

                    <div class="chatbot-message-meta">
                        <span class="chatbot-sender-name">
                            {{ msg.role === 'user' ? firstName() : 'AI Assistant' }}
                        </span>
                        <span class="chatbot-timestamp">
                            {{ msg.timestamp | date:'MM/dd/yyyy HH:mm:ss' }}
                        </span>
                    </div>

                    <div class="chatbot-bubble" [innerHTML]="msg.text"></div>
                </div>

                <!-- Follow-ups -->

                <div class="chatbot-followups" *ngIf="followUps.length">

                    <!--  Title -->
                    <div class="chatbot-followup-title">
                        Suggested Questions
                    </div>

                    <!-- Chips -->
                    <div class="chatbot-followup-list">
                        <button *ngFor="let item of followUps"
                                class="chatbot-chip"
                                (click)="sendFollowup(item)">
                            {{ item }}
                        </button>
                    </div>

                </div>


                <!-- Typing -->
                <div class="chatbot-message bot" *ngIf="isTyping">
                    <div class="chatbot-bubble typing-indicator">
                        <span></span><span></span><span></span>
                    </div>
                </div>

            </div>

            <!-- Input -->
            <div class="chatbot-input-area">

                <div class="chatbot-voice-toggle">
                    <label>
                        <input type="checkbox" [(ngModel)]="isVoiceEnabled" />
                        Enable voice listening
                    </label>
                </div>

                <div class="chatbot-input-row">
                    <textarea class="chatbot-input"
                              rows="1"
                              placeholder="Type a message..."
                              [(ngModel)]="inputText"
                              (keydown)="onKeydown($event)"
                              [disabled]="isTyping"></textarea>

                    <button class="chatbot-send-btn"
                            (click)="sendMessage()"
                            [disabled]="!inputText.trim() || isTyping">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" fill="currentColor" />
                        </svg>
                    </button>
                </div>

            </div>

        </ng-container>

    </div>
</div>
